export default function (value, symbol) {
  var parts = value.toString().split('.')

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  var result = parts.join('.')

  if (symbol === 'percentage') {
    return result + '%'
  } else if (symbol === 'currency') {
    return '$' + result
  } else {
    return result
  }
}
